/**
 * @file 数字人相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';

/**
* 发起预检人像资源。
 *
 */
export const preCheck = async params => {
    return request(
        API.PRE_CHECK, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const preCheckResult = async params => {
    return request(
        API.PRE_CHECK_RESULT, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 确认是否重做
 * @returns Promise
 */
export const confirmRemakeCharacter = async params => {
    return request(
        API.REMAKE_CHARACTER, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 创建人像资源绿幕
 * @returns Promise
 */
export const createCharacterResource = async (api, params) => {
    return request(
        api, {
            method: 'POSTJSON',
            body: params
        }
    );
};

// /**
//  * 删除人像资源
//  * @returns Promise
//  */
// export const delCharacterResource = async params => {
//     return request(
//         API.DEL_CHARACTER_RESOURCE, {
//             method: 'POSTJSON',
//             body: params
//         }
//     );
// }

/**
 * 列表种删除人像
 * @returns Promise
 */
export const delCharacter = async params => {
    return request(
        API.DEL_CHARACTER_RESOURCE, {
            method: 'POSTJSON',
            body: {
                ...params,
                status: 4
            }
        }
    );
};

/**
 * 人像排序
 * @returns Promise
 */
export const sortCharacter = async params => {
    return request(
        API.SORT_CHARACTER, {
            method: 'POSTJSON',
            body: {
                ...params
            }
        }
    );
};

/**
 * 人像重命名
 * @returns Promise
 */
export const renameCharacter = async params => {
    return request(
        API.RENAME_CHARACTER, {
            method: 'POSTJSON',
            body: {
                ...params
            }
        }
    );
};

/**
 * 判断数字人是否已经被使用
 * @returns Promise
 */
export const checkCharacterStatus = async params => {
    return request(
        API.SCRIPT_IS_USE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取人像母版信息
 * @returns Promise
 */
export const getCharacterOptions = async params => {
    return request(
        API.GET_CHARACTER_OPTIONS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 保存人像母版信息
 * @returns Promise
 */
export const setCharacterOptions = async params => {
    return request(
        API.SET_CHARACTER_OPTIONS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 修改人像名称
 * @returns Promise
 */
export const saveCharacterName = async params => {
    return request(
        API.SAVE_CHARACTER_NAME, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 更新互动配置信息
 * @returns Promise
 */
export const saveInteractRules = async params => {
    return request(
        API.SAVE_INTERACT_RULES, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 预检反馈
 * @returns Promise
 */
export const preCheckFeedback = async params => {
    return request(
        API.PRE_CHECK_FEED_BACK, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 形象制作反馈
 * @returns Promise
 */
export const feedBackAnchor = async params => {
    return request(
        API.FEED_BACK_ANCHOR, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 添加收藏
 * @returns Promise
 */
export const addCollectionCharacter = async params => {
    return request(
        API.ADD_CHARACTER_COLLECTION, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 取消收藏
 * @returns Promise
 */
export const delCollectionCharacter = async params => {
    return request(
        API.DEL_CHARACTER_COLLECTION, {
            method: 'POSTJSON',
            body: params
        }
    );
};